/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown } from "primereact/dropdown";
import { useAppDispatch, useAppSelector } from "../../hooks/ReduxHooks";
import { useGetAdminInstitutionsQuery } from "../../store/services/institutions-admins";
import { Rootstate } from "../../store/store";
import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { useNavigate } from "react-router-dom";
import { Institution } from "../../models/institutions";
import { actions } from "../../store/slices/AuthSlice";

interface SelectInstitutionProps {
  expanded?: boolean;
}

const SelectInstitution = ({ expanded = true }: SelectInstitutionProps) => {
  const dispatch = useAppDispatch();

  const [institutionSelect, setInstitutionSelect] = useState<Institution>();
  const op = useRef<OverlayPanel>(null);
  const navigate = useNavigate();
  const { user, institutionId } = useAppSelector(
    (state: Rootstate) => state.auth
  );

  const { data, isLoading } = useGetAdminInstitutionsQuery(user?.id || "");

  const handleSelectInstitution = (
    value: Institution,
    shouldNavigate = true
  ) => {
    dispatch(
      actions.saveInstitution({
        institutionId: value.id.toString(),
        planId: value.planId?.toString() ?? null,
        owner: value.owner ?? false,
      })
    );
    setInstitutionSelect(value);
    if (shouldNavigate) {
      navigate("/panel/institution");
    }
  };

  useEffect(() => {
    if (data?.length) {
      if (institutionId) {
        const current = data.find((i) => i.id.toString() === institutionId);
        if (current) {
          setInstitutionSelect(current);
          return;
        }
      }
      handleSelectInstitution(data[0], false);
    }
    return () => {};
  }, [data]);

  return (
    <>
      {expanded ? (
        <div className="institution-selector-expanded">
          <div className="institution-label">
            <i className="pi pi-building"></i>
            <span>Institución</span>
          </div>
          <Dropdown
            id="institution"
            name="institution"
            className="institution-dropdown w-full"
            optionLabel="name"
            value={institutionSelect}
            onChange={(e) => handleSelectInstitution(e.value)}
            emptyMessage="No se encontraron datos"
            placeholder="Seleccionar institución"
            options={[...(data || [])]}
            disabled={isLoading}
          />
        </div>
      ) : (
        <>
          <Button
            className="institution-btn-collapsed"
            type="button"
            icon="pi pi-building"
            tooltip="Seleccionar institución"
            tooltipOptions={{ position: "right" }}
            onClick={(e) => op.current?.toggle(e)}
            text
          />
          <OverlayPanel
            ref={op}
            dismissable={false}
            onMouseLeave={(e) => op.current?.toggle(e)}
            data-pr-position="right"
            style={{
              background: "var(--surface-card)",
              border: "1px solid var(--surface-border)",
              borderRadius: "0.75rem",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              minWidth: "250px",
            }}
          >
            <div className="p-2">
              <div className="institution-label mb-2">
                <i className="pi pi-building"></i>
                <span>Institución</span>
              </div>
              <Dropdown
                id="institution"
                name="institution"
                className="institution-dropdown w-full"
                optionLabel="name"
                value={institutionSelect}
                onChange={(e) => handleSelectInstitution(e.value)}
                placeholder="Seleccionar institución"
                emptyMessage="No se encontraron datos"
                options={[...(data || [])]}
                disabled={isLoading}
              />
            </div>
          </OverlayPanel>
        </>
      )}
    </>
  );
};

export default SelectInstitution;
